import type { CostEstimate } from '@cartwheel/api/v1'
import { CommercialEstimateDisplay } from './commercial-estimate-display'
import { MedicaidEstimateDisplay } from './medicaid-estimate-display'
import { OtherEstimateDisplay } from './other-estimate-display'
import { SelfPaidEstimateDisplay } from './self-paid-estimate-display'

// Dispatches to the type-specific display partial — analog of the
// case/when in app/views/client_cost_estimates/show.html.erb.
export function EstimateDisplay({ estimate }: { estimate: CostEstimate }) {
  switch (estimate.estimate_type) {
    case 'commercial':
      return <CommercialEstimateDisplay estimate={estimate} />
    case 'medicaid':
      return <MedicaidEstimateDisplay estimate={estimate} />
    case 'self_pay':
      return <SelfPaidEstimateDisplay estimate={estimate} />
    case 'other':
      return <OtherEstimateDisplay estimate={estimate} />
  }
}
